import { defaultFantomProviderConfiguration } from 'src/features/on-chain/calculation-manager/providers/dexes/fantom/default-constants';

export const SPIRIT_SWAP_CONTRACT_ADDRESS = '0x16327E3FbDaCA3bcF7E38F5Af2599D2DDc33aE52';

export const SPIRIT_SWAP_PROVIDER_CONFIGURATION = defaultFantomProviderConfiguration;
